// #region Global Imports
import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
// eslint-disable-next-line import/no-extraneous-dependencies
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
// #endregion Global Imports

// #region Local Imports
import Reducers from "./Reducers";
import { createWrapper, Context } from "next-redux-wrapper";
// #endregion Local Imports

// export const makeStore:MakeStore = (initialState: {}) => {
//     return createStore(
//         Reducers,
//         initialState,
//         composeWithDevTools(applyMiddleware(thunkMiddleware))
//     );
// };
const makeStore = (context: Context) =>
  createStore(Reducers, composeWithDevTools(applyMiddleware(thunkMiddleware)));
export const wrapper = createWrapper(makeStore, { debug: true });
